//================================================================
//  Page: Vendor
//================================================================

//  Purpose: This page shows the current Vendor

//  Example:
//    <Vendor></Vendor>    

//================================================================


// Libraries
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';

// Contexts
import { GetRoles, GetUser } from '../../../../Library/GlobalContexts';

// Components
import PageComponent from '../../../../Components/PageComponent/PageComponent';
import TabView from '../../../../Components/TabView/TabView';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadCrumbs';
import StatusLabel from '../../../../Components/StatusLabel/StatusLabel';

// Tabs
import Overview from './Tabs/Overview';
import VendorRiskRating from './Tabs/VendorRiskRating';

// Functions
import DocumentListener from '../../../../Library/DocumentListener';
import CheckInventoryRole from '../../../../Library/CheckInventoryRole';

// Images

// CSS


export default function Vendor() {

  //------------------------------------------------------
  //  React Router & useContexts
  //------------------------------------------------------

  const routerUseLocation = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const getUser = useContext(GetUser);
  const getRoles = useContext(GetRoles);

  //------------------------------------------------------
  //  useStates
  //------------------------------------------------------

  // Used to save page status > 'pending', 'onload', 'error-invalid', 'error-fatal'
  const [pageStatus, setPageStatus] = useState();

  // Holds the application document from 
  const [vendorDoc, setVendorDoc] = useState();

  //------------------------------------------------------
  //  useEffects
  //------------------------------------------------------

  // Query Listener
  // - Get all Overview with the status of 'Active'
  useEffect(() => {

    const vendorId = params.id;

    if (vendorId === '') return;
    if (vendorId === null) return;
    if (getRoles === undefined) return;
    if (getUser === undefined) return;

    // ============================================
    //  Perform role check
    // ============================================

    const roleStatus = CheckInventoryRole('vendors', getRoles, getUser);
    if (roleStatus === 'access-denied') return navigate('/inventory?view=vendors');

    // ============================================
    //  Fetch Data
    // ============================================

    function onLoadChange(document) {

      if (document === undefined) return  setPageStatus('forbidden');

      setVendorDoc(document);
      setPageStatus('onload')

    }

    function onError(error) {

      console.log(error);
      setPageStatus('error-fatal');

    }

    const unsubscribe = DocumentListener('vendors', vendorId, onLoadChange, onLoadChange, onError);

    return () => {
      unsubscribe();
    };

    // eslint-disable-next-line
  }, [getUser, getRoles])

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <PageComponent
      pageStatus={pageStatus}
      header={
        <div className='Page-Header-Container' hidden={pageStatus !== 'onload'}>

          <BreadCrumbs
            rootLinkName='Vendors'
            rootLinkRoute={`/${routerUseLocation.pathname.split('/')[1]}?view=vendors`}
            childLinkName={vendorDoc?.vendorname}
          ></BreadCrumbs>

          <div className='flex flex-row gap-4'>
            <p className='font-medium text-[20px] mb-0'>{vendorDoc?.vendorname}</p>
            <StatusLabel status={vendorDoc?.vendorstatus}></StatusLabel>
          </div>
        </div>
      }
      body={
        <TabView
          defaultView={1}

          //------------------------------------------------------
          // Overview
          //------------------------------------------------------

          oneTitle={'Overview'}
          oneRoute={`/inventory/vendor/${params.id}?view=overview`}
          oneContent={
            <Overview></Overview>
          }

          //------------------------------------------------------
          // Vendor Risk Rating
          //------------------------------------------------------

          twoTitle={'Vendor Risk Rating'}
          twoRoute={`/inventory/vendor/${params.id}?view=vendor-risk-rating`}
          twoContent={
            <VendorRiskRating></VendorRiskRating>
          }

        ></TabView>
      }
    ></PageComponent>
  )
}
